import { render, staticRenderFns } from "./StatusToggle.vue?vue&type=template&id=a3e2126c&"
import script from "./StatusToggle.vue?vue&type=script&lang=ts&"
export * from "./StatusToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports